// extracted by mini-css-extract-plugin
module.exports =  {"dropdownListRoot":"DropdownList-module__dropdownListRoot--DB0GK","hasV2Styles":"DropdownList-module__hasV2Styles--aRL1v"};